import { InternCategoryIcon } from '../intern/category-icon';
import { InternIcon } from '../intern/icon';
import { LinkActionLink } from '../link/action-link';
import { LinkAssetLink } from '../link/asset-link';
import { LinkExternalLink } from '../link/external-link';
import { LinkInternalLink } from '../link/internal-link';
import { LinkMenuLink } from '../link/menu-link';
import { LinkThematischerLink } from '../link/thematischer-link';

/**
 * Model definition for button
 */
export interface ContentButton {
  __component: 'content.button';
  id: string;
  variant?: 'standard' | 'inverted' | 'tab' | 'category';
  color?: 'primary' | 'secondary' | 'inherit';
  size?: 'small' | 'medium' | 'large' | 'header';
  fullWidth?: boolean;
  startIcon?: InternIcon;
  endIcon?: InternIcon;
  categoryIcon?: InternCategoryIcon;
  link?: [LinkInternalLink | LinkExternalLink | LinkThematischerLink | LinkActionLink | LinkAssetLink | LinkMenuLink];
}

export function isContentButton(obj: { __component?: string }): obj is ContentButton {
  return obj.__component === 'content.button';
}
